import { init } from "../../init";
import * as actionTypes from "./actionTypes";

/** 詳細設定の画質 */
export const detailQuality = (detailQuality) => {
    return {
        type: actionTypes.DETAIL_QUALITY,
        detailQuality: detailQuality
    }
}